<template>
  <div
    :id="containerId"
    ref="scaleRef"
  />
</template>

<script setup>
import {ref, computed, inject, onMounted, watch} from 'vue';
import {ScaleLine} from 'ol/control.js';

import {DEFAULT_SCREEN_DPC,
  dpc2dpi} from '@/util-scale';

// #region Props, Emits
const props = defineProps({
  dpc: {
    type: Number,
    default: DEFAULT_SCREEN_DPC,
  },
  isPrintScale: {
    type: Boolean,
    default: false,
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const scaleControl = ref(null);
const scaleRef = ref(null);
const viewMapRef = inject('instanceMapRef');
const printMapRef = inject('instancePrintMapRef');
const containerId = computed(() => {
  if (!!props.isPrintScale) {
    return 'print-scale-bar';
  }
  return 'scale-bar';
});
const mapRef = computed(() => {
  if (!!props.isPrintScale) {
    return printMapRef?.value;
  }
  return viewMapRef?.value;
});
// #endregion

// #region Functions
// Pre: scaleRef?.value
function createScaleBar(map) {
  const options = {
    units: 'metric',
    steps: 4,
    bar: true,
    minWidth: 140,
    text: true,
    target: scaleRef.value,
    dpi: dpc2dpi(props.dpc),
  };
  return new ScaleLine(options);
}
function removeScaleBar(map) {
  if (!!scaleControl?.value) {
    map.removeControl(scaleControl.value);
  }
}
function addScaleBar(map) {
  const newScaleControl = createScaleBar(map);
  map.addControl(newScaleControl);
  scaleControl.value = newScaleControl;
}
// #endregion

// #region Effects, Hooks
watch([mapRef, props], ([newMapRef, _newProps]) => {
  if (!!newMapRef && !!scaleRef?.value) {
    removeScaleBar(newMapRef);
    addScaleBar(newMapRef);
  }
});
onMounted(async () => {
  if (!!mapRef?.value && !!scaleRef?.value) {
    removeScaleBar(mapRef.value);
    addScaleBar(mapRef.value);
  }
});
// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
  #scale-bar .ol-scale_bar {
    z-index: 0 !important;
  }
</style>
